import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { useEvent } from "shared/lib/useEvent"
import { WithClassName } from "shared/types/WithClassName"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormControlsProps extends WithClassName {}

export const ProjectFormControls = React.memo(
  ({ className }: ProjectFormControlsProps) => {
    const { t } = useTranslation()
    const { isReadonly, onCancel } = useProjectFormContext()

    const handleSubmitClick = useEvent(() => {
      setTimeout(() => onCancel?.(), 50)
    })

    if (isReadonly) {
      return null
    }

    return (
      <div className={classNames("project-form__form-controls", className)}>
        <Button variant={ButtonVariant.SECONDARY} onClick={onCancel}>
          {t("General.Cancel")}
        </Button>
        <Button
          type="submit"
          variant={ButtonVariant.PRIMARY}
          onClick={handleSubmitClick}
        >
          {t("General.Confirm")}
        </Button>
      </div>
    )
  }
)

ProjectFormControls.displayName = "ProjectFormControls"
